import { Phone, Mail } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { usePublicSettings, telHref } from "../../lib/publicSettings";

export const ContactLine = ({ variant = "block", testid }) => {
  const { t } = useLang();
  const settings = usePublicSettings();
  const contact = settings?.contact;
  if (!contact) return null;
  return (
    <div className={`contact-line contact-line-${variant}`} data-testid={testid}>
      <span className="contact-line-label">{t.contactInfo.label}</span>
      <a href={telHref(contact.phone)} className="contact-line-link" data-testid={`${testid}-phone`}><Phone aria-hidden="true" />{contact.phone}</a>
      <a href={`mailto:${contact.email}`} className="contact-line-link" data-testid={`${testid}-email`}><Mail aria-hidden="true" />{contact.email}</a>
    </div>
  );
};
